exports = module.exports = require("../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, "@media (max-width: 768px) {\n  .modal-image {\n    max-width: 90% !important;\n    max-height: 500px !important; }\n  #modal-close-button {\n    right: -170px !important; } }\n", ""]);

